import { makeStyles } from '@material-ui/core'
export const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(0, 1),
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  iconButton: {
    padding: '0',
  },
  delete: {
    color: theme.palette.primary.delete,
  },
}))
